import { assign, identity, isString } from 'lodash';
import { parse } from 'content-type';
import qs from 'qs';
import { ACCEPT, CONTENT_TYPE } from 'http-header-fields';

const isUrlEncoded = type => (
  type && parse(type).type === 'application/x-www-form-urlencoded'
);

export default () => ({ options }) => {
  if (isUrlEncoded(options.headers[CONTENT_TYPE]) && !isString(options.body)) {
    assign(options, {
      body: qs.stringify(options.body),
    });
  }

  return isUrlEncoded(options.headers[ACCEPT])
    ? response => response.text().then(qs.parse)
    : identity;
};



// WEBPACK FOOTER //
// ./src/Api/middleware/urlEncoded.js